import '@/assets/css/tailwind.css';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import firebase from 'firebase/app';
import 'firebase/auth';
import VCalendar from 'v-calendar';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import App from './App.vue';
import * as interceptor from './interceptor';
import router from './router';
import store from './store';

Vue.use(VueApexCharts);
Vue.use(VCalendar);

Vue.component('apexchart', VueApexCharts);

// FILTERS

Vue.filter('date', (value, form) => {
  if (!value) return '';
  value = value.toString();
  // 2021-09-20T14:23:43.239Z
  // const temps = parse(value, "yyyy-MM-dd'T'HH:mm:ss.SSSX", new Date());
  return format(parseISO(value), form);
});

Vue.filter('filler', (value) => {
  return value === null || value === undefined ? '-' : value;
});

Vue.filter('titlecase', (value) => {
  if (value) {
    const words = value.toLowerCase().split(' ');
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].slice(1);
    }
    return words.join(' ');
  }
  return '';
});

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

// FIREBASE

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};
firebase.initializeApp(firebaseConfig);

let app;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      interceptor,
      render: (h) => h(App),
    }).$mount('#app');
  }
});
